export default __webpack_public_path__ + "static/media/first_order.3212312f.svg";